<template>
  <v-app-bar app dense class="top-bar" @click="hideMainMenu()" @contextmenu.prevent>
    <v-app-bar-nav-icon class="ml-2" @click="toggleMainMenu($event)"></v-app-bar-nav-icon>
    <v-toolbar-title class="pl-7">
      <router-link :to="logo"><h1 class="logo"/></router-link>
      <!-- Gnb.vue로 옮김.2024.07.02.KWShin. -->
      <!--router-link to="/" class="dummy-center-logo">&nbsp;</router-link-->
    </v-toolbar-title>
    <v-spacer />
    <v-toolbar-items @click="hideMainMenu()">
      <BtnAlert />
      <BtnPreference />
      <BtnUser />
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
import bus from '@/utils/bus';
import BtnAlert from './BtnAlert.vue';
import BtnPreference from './BtnPreference.vue';
import BtnUser from './BtnUser.vue';

export default {
  components: {
    BtnAlert,
    BtnPreference,
    BtnUser,
  },
  data: () => ({
    logo: {
      // '/'로 되어 있으면 page-title이 표시되지 않아서 변경함.2024.07.04.KWShin.
      // path: '/',
      path: '/views/overview/whole',
    },
  }),
  methods: {
    hideMainMenu() {
      bus.$emit('toggle-main-menu', false);
    },
    toggleMainMenu(e) {
      e.stopPropagation();
      e.preventDefault();
      bus.$emit('toggle-main-menu');
    },
  },
};
</script>
